import {
  IQuestionnaireRegistry,
  IQuestionnaireGlossaryRepository,
} from "../../../domain/questionnaire";
import { QuestionnaireGlossaryRepository } from "./QuestionnaireGlossaryRepository";

export class QuestionnaireRegistry implements IQuestionnaireRegistry {
  constructor(private readonly _getToken: () => string) {}

  getGlossaryRepository(): IQuestionnaireGlossaryRepository {
    return new QuestionnaireGlossaryRepository(this._getToken);
  }
}
